import Vue from 'vue'
import Router from 'vue-router'
import position from '../components/position.vue'
import changeBefore from '../components/changeBefore.vue'
import changeAfter from '../components/changeAfter.vue'
import xs from '../components/xs.vue'
import txList from '../components/txList.vue'
import companyAudit from '../components/companyAudit'
import personAudit from '../components/personAudit'
import moneyReward from '../components/moneyReward'
import authApply from '../components/authApply'
import zjList from '../components/zjList'
import login from '../components/login'
import userList from '../components/userList'
import ptStatus from '../components/ptStatus'
import jobNotice from '../components/jobNotice'
import dhkList from '../components/dhkList'
import rankClassList from '../components/rankClassList'
import viewRank from '../components/viewRank'
import paUser from '../components/paUser'
import banner from '../components/banner'




Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'ptStatus',
      component: ptStatus
    },
    {
      path: '/position',
      name: 'position',
      component: position
    },
    {
      path: '/changeBefore',
      name: 'changeBefore',
      component: changeBefore
    },
    {
      path: '/changeAfter',
      name: 'changeAfter',
      component: changeAfter
    },
    {
      path: '/xs',
      name: 'xs',
      component: xs
    },
    {
      path: '/txList',
      name: 'txList',
      component: txList
    },
    {
      path: '/companyAudit',
      name: 'companyAudit',
      component: companyAudit
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/userList',
      name: 'userList',
      component: userList
    },
    {
      path: '/personAudit',
      name: 'personAudit',
      component: personAudit
    },
    {
      path: '/moneyReward',
      name: 'moneyReward',
      component: moneyReward
    },
    {
      path: '/authApply',
      name: 'authApply',
      component: authApply
    },
    {
      path: '/zjList',
      name: 'zjList',
      component: zjList
    },
    {
      path: '/jobNotice',
      name: 'jobNotice',
      component: jobNotice
    },
    {
      path: '/dhkList',
      name: 'dhkList',
      component: dhkList
    },
    {
      path: '/rankClassList',
      name: 'rankClassList',
      component: rankClassList
    },
    {
      path: '/viewRank',
      name: 'viewRank',
      component: viewRank
    },
    {
      path: '/paUser',
      name: 'paUser',
      component: paUser
    },
    {
      path: '/banner',
      name: 'banner',
      component: banner
    }
  ]
})


export default router
jobNotice